'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

var _UISearchInput = require('UIComponents/input/UISearchInput');

var _UISearchInput2 = _interopRequireDefault(_UISearchInput);

var _UIHeader = require('UIComponents/layout/UIHeader');

var _UIHeader2 = _interopRequireDefault(_UIHeader);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITable = require('UIComponents/table/UITable');

var _UITable2 = _interopRequireDefault(_UITable);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _reactRouterDom = require('react-router-dom');

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _lib = require('../lib');

var _UIPaginator = require('UIComponents/paginator/UIPaginator');

var _UIPaginator2 = _interopRequireDefault(_UIPaginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Users = function (_Component) {
  _inherits(Users, _Component);

  function Users(props) {
    _classCallCheck(this, Users);

    var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this, props));

    _this.defaultValue = (0, _lib.query)().s || '';
    _this.update = _this.update.bind(_this);
    _this.jump = _this.jump.bind(_this);
    return _this;
  }

  _createClass(Users, [{
    key: 'update',
    value: function update(evt) {
      this.props.search(evt.target.value);
    }
  }, {
    key: 'jump',
    value: function jump(_ref) {
      var value = _ref.target.value;

      this.props.jump(value - 1);
    }
  }, {
    key: 'renderRow',
    value: function renderRow(user) {
      var company = null;
      if (user.company) {
        if (user.companyWebsite) {
          company = _react2.default.createElement(
            _UILink2.default,
            { href: user.companyWebsite },
            user.company
          );
        } else {
          company = _react2.default.createElement(
            'span',
            null,
            user.company
          );
        }
      }
      var subheading = null;
      if (user.jobTitle) {
        if (company) {
          subheading = _react2.default.createElement(
            _UITruncateString2.default,
            null,
            user.jobTitle,
            ' at ',
            company
          );
        } else {
          subheading = _react2.default.createElement(
            _UITruncateString2.default,
            null,
            user.jobTitle
          );
        }
      } else if (company) {
        subheading = _react2.default.createElement(
          _UITruncateString2.default,
          null,
          company
        );
      }
      var link = user.username ? user.username : 'users/' + user.id;
      return _react2.default.createElement(
        'tr',
        { key: user.id },
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'div',
            { className: 'cell-wrap' },
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: link, className: 'avatar' },
              _react2.default.createElement(_UISimpleAvatar2.default, { src: user.avatarUrl + '/48', size: 'md' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'headline' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: link },
                  user.firstName + ' ' + user.lastName
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _Small2.default,
                  { use: 'help' },
                  subheading
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderRows',
    value: function renderRows() {
      var that = this;
      return this.props.users.list.map(function (user) {
        return that.renderRow(user);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$users = this.props.users,
          page = _props$users.page,
          size = _props$users.size,
          total = _props$users.total;

      return _react2.default.createElement(
        _NavApp2.default,
        { title: 'Search' },
        _react2.default.createElement(
          'div',
          { className: 'users-page' },
          _react2.default.createElement(
            'div',
            { className: 'search' },
            _react2.default.createElement(_UISearchInput2.default, {
              use: 'on-dark',
              minimumSearchCount: 3,
              onChange: this.update,
              defaultValue: this.defaultValue })
          ),
          _react2.default.createElement(_UIHeader2.default, { title: 'Members', use: 'condensed', className: 'header' }),
          _react2.default.createElement(
            _UITable2.default,
            { truncated: true },
            _react2.default.createElement(
              'tbody',
              null,
              this.renderRows()
            )
          ),
          _react2.default.createElement(_UIPaginator2.default, { onPageChange: this.jump, page: page + 1, pageCount: Math.floor((total - 1) / size + 1) })
        )
      );
    }
  }]);

  return Users;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var users = _ref2.users;

  return { users: users };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  search: function search(term) {
    return (0, _actions.createAction)(_actions2.default.USERS_ASK_START, term);
  },
  jump: function jump(page) {
    return (0, _actions.createAction)(_actions2.default.USERS_ASK_PAGE, page);
  }
})(Users);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/Users.js
// module id = 177
// module chunks = 0